import React, {useEffect, useState} from "react";

import closeV2 from '../../../static/image/v2/popup/closeV2.png'
import plusBtn from '../../../static/image/v2/menu/plusBtn.png'
import minusBtn from '../../../static/image/v2/menu/minusBtn.png'
import {closePopup} from "../../../static/js/Common2";
import {
  changeOptionGrpList, changeOptionList, deleteOptionGrp,
  getOptionList,
  modifyOptionGrp,
  newOptionGrp
} from "../../../static/js/service/optionService";
import {OptionGrpDragV2} from "./OptionGrpDragV2";
import {OptionDragV2} from "./OptionDragV2";

export default function OptionGrpPopupV2(props) {
  let shopId = props.shopId;
  let optionGrpList = props.optionGrpList;
  let [optionList, setOptionList] = useState([]);
  const reset = props.reset;
  const setReset = props.setReset;

  useEffect(() => {
    function handleClickOutside(e) {
      let select = document.querySelectorAll(".popupSelect");
      select.forEach((element) => {
        element.classList.remove("active");
      })

      if(e.target.classList.contains("selectText")) {
        let dataHref = e.target.getAttribute("data-href");
        let selectBox = document.getElementById(`${dataHref}`);
        selectBox.classList.add("active");
      }
    }

    document.addEventListener("click", handleClickOutside);
  }, [optionList]);

  function closeNewOptionPopup() {
    document.getElementById("optionGrpNameInput").value = "";
    document.getElementById("optionGrpStates1").setAttribute("data-id", 1);
    document.querySelector("#optionGrpStates1 .selectText").innerText = "필수";
    document.getElementById("maxNumber1").value = 1;
    document.querySelector("#maxBtnBox1 .flexTitle").innerText = "선택 갯수";

    let optionBox = document.getElementById("newOptionList1");
    optionBox.innerHTML = "";
    let div = document.createElement("div");
    div.innerHTML = `<input type='text' class='newOptionName' name='newOptionName' placeholder='옵션명' />` +
      `<input type='number' class='newOptionPrice priceCut100' name='newOptionPrice' /> 원`

    div.setAttribute("class", 'newOptionBox addNewOption');

    div.querySelector(".newOptionPrice").addEventListener("change", (e) => {
      let n = e.target.value;

      if(n < 0) {
        alert('0원 이상 입력가능합니다.')
        e.target.value = 0
      }
    })

    optionBox.appendChild(div);
    closePopup("optionAddPopup");
  }

function optionSelect1(id, text, number) {
  document.getElementById(`optionGrpStates${number}`).classList.remove("active");
  document.querySelector(`#optionGrpStates${number}`).setAttribute("data-id", id);
  document.querySelector(`#optionGrpStates${number} .selectText`).innerText = text;

  document.getElementById(`maxNumber${number}`).value = 1;
  document.getElementById(`maxBtnBox${number}`).classList.remove("hide"); // 항상 노출

    document.querySelector(`#maxBtnBox${number} .flexTitle`).innerText = 
    id === 1 ? '선택 갯수' : '최대 선택갯수'; // 필수, 선택 옵션에 따라 랜더링 되는 텍스트 변경
}


  function plusBtnEvnet(number) {
    let value = document.getElementById(`maxNumber${number}`).value;
    document.getElementById(`maxNumber${number}`).value = Number(value) + 1;
  }


  function minusBtnEvnet(number) {
    let value = Number(document.getElementById(`maxNumber${number}`).value);
    if(value > 1) {
      document.getElementById(`maxNumber${number}`).value = Number(value) - 1;
    } else {
      console.log("최소 1개 이상만 설정할 수 있습니다.");
    }
  }

  function newOptionAddEvent(number) {
    let div = document.createElement("div");
    div.innerHTML = `<input type='text' class='newOptionName' name='newOptionName' placeholder='옵션명' />` +
                    `<input type='number' class='newOptionPrice priceCut100' name='newOptionPrice' /> 원` +
                    `<button type='button' class='newOptionRemoveBtn'>삭제</button>`

    div.setAttribute("class", 'newOptionBox addNewOption');

    document.getElementById(`newOptionList${number}`).appendChild(div);

    div.lastChild.addEventListener("click", () => {
      div.remove();
    });

    div.querySelector(".newOptionPrice").addEventListener("change", (e) => {
      let n = e.target.value;

      if(n < 0) {
        alert('0원 이상 입력가능합니다.')
        e.target.value = 0
      }
    })
  }

  function newOptionGrpBtn() {
    let optionGrpName = document.getElementById("optionGrpNameInput").value;
    let requiredChoice = document.getElementById("optionGrpStates1").getAttribute("data-id");
    let required = Number(requiredChoice) === 1;
    let maxNumber = document.getElementById("maxNumber1").value;
    let optionList = [];
    let result = true;

    let exposSeq = 1
    if(optionGrpList.length !== 0) {
      optionGrpList.sort(function(a, b) {
        return parseFloat(a.visibleIndex) - parseFloat(b.visibleIndex)
      })

      exposSeq = optionGrpList[optionGrpList.length - 1].visibleIndex + 1
    }


    if(optionGrpName === '') {
      alert('옵션 그룹명을 입력해주세요');
      return false;
    }
    if(Number(maxNumber) < 1) {
      alert('최소 1개 이상만 설정할 수 있습니다.');
      return false;
    }

    let newOptionBox = document.querySelectorAll("#newOptionList1 .newOptionBox");
    newOptionBox.forEach((elemet, index) => {
      let newOptionName = elemet.querySelector(".newOptionName").value;
      let newOptionPrice = Number(elemet.querySelector(".newOptionPrice").value);

      if(newOptionName === '') {
        alert('옵션명을 입력해주세요');
        result = false;
        return false;
      }

      let isSelected = false;
      if(required && index === 0) {
        isSelected = true;
      }

      optionList.push({
        status: 1,
        name: newOptionName,
        cost: newOptionPrice,
        visibleIndex: index + 1,
        isVisible: true,
        isSelected: isSelected
      })
    })

    let data = {
      shopId: shopId,
      addOptionGroupList: [{
        name: optionGrpName,
        desc: "",
        requiredChoice: required,
        maxChoiceCount: Number(maxNumber),
        visibleIndex: exposSeq,
        isVisible: true,
        optionList: optionList
      }]
    }

    if (result) {
      document.getElementById("optionAddBtn").setAttribute("disabled", true);
      newOptionGrp(shopId, data);
    }
  }

  function modifyOptionGrpBtn() {
    let optionGrpId = document.getElementById("optionGrpIndex").value;
    let optionGrpName = document.getElementById("optionGrpNameInput2").value;
    let requiredChoice = document.getElementById("optionGrpStates2").getAttribute("data-id");
    let required = Number(requiredChoice) === 1;
    let maxNumber = document.getElementById("maxNumber2").value;
    let addOptionList = [];
    let modifyOptionList = [];
    let deleteOptionList = [];
    let first = true;
    let result = true;

    if(optionGrpName === '') {
      alert('옵션 그룹명을 입력해주세요');
      return false;
    }
    if(Number(maxNumber) < 1) {
      alert('최소 1개 이상만 설정할 수 있습니다.');
      return false;
    }

    let newOptionBox = document.querySelectorAll("#newOptionList2 .newOptionBox");
    newOptionBox.forEach((elemet, index) => {
      let newOptionName = elemet.querySelector(".newOptionName").value;
      let newOptionPrice = Number(elemet.querySelector(".newOptionPrice").value);
      let dataId = elemet.getAttribute("data-id");
      let dataType = elemet.getAttribute("data-type");
      if(!dataType) {
        dataType = 1;
      }

      let isSelected = false;
      if(!elemet.classList.contains("hide") && required && first && Number(dataType) === 1) {
        isSelected = true;
        first = false;
      }

      if(elemet.classList.contains("hide")) {
        deleteOptionList.push(Number(dataId));
      } else if(elemet.classList.contains("modifyNewOption")) {
        if(newOptionName === '') {
          alert('옵션명을 입력해주세요');
          result = false;
          return false;
        }

        modifyOptionList.push({
          optionId: dataId,
          name: newOptionName,
          cost: newOptionPrice,
          visibleIndex: index + 1,
          isSelected: isSelected
        });
      } else {
        if(newOptionName === '') {
          alert('옵션명을 입력해주세요');
          result = false;
          return false;
        }

        addOptionList.push({
          status: 1,
          name: newOptionName,
          cost: newOptionPrice,
          visibleIndex: index + 1,
          isVisible: true,
          isSelected: isSelected
        })
      }
    })

    let data = {
      name: optionGrpName,
      requiredChoice: required,
      maxChoiceCount: Number(maxNumber),
      addOptionList: addOptionList,
      setOptionList: modifyOptionList,
      removeOptionIdList: deleteOptionList
    }

    if (result) {
      document.getElementById("optionSetBtn").setAttribute("disabled", true);
      sessionStorage.setItem("targetId", `menuListBox${optionGrpId}`);
      modifyOptionGrp(shopId, optionGrpId, data);
    }
  }

  function changeOptionGrpListBtn() {
    let itemBox = document.querySelectorAll("#popupDragBox1 .popupDrag li");
    let data = [];
    itemBox.forEach((element, index) => {
      let dataId = element.getAttribute("data-id");
      data.push({
        optionGroupId: Number(dataId),
        visibleIndex: index + 1
      })
    })

    document.getElementById("menuGrp2Btn").setAttribute("disabled", true);
    changeOptionGrpList(shopId, data)
  }

  function changeOptionListBtn() {
    let itemBox = document.querySelectorAll("#popupDragBox2 .popupDrag li");
    let grpId = document.getElementById("menuDrgSelect").getAttribute("data-id");
    let data = [];
    itemBox.forEach((element, index) => {
      let dataId = element.getAttribute("data-id");
      data.push({
        optionId: Number(dataId),
        visibleIndex: index + 1
      })
    })

    document.getElementById("menuPopup3Btn").setAttribute("disabled", true);
    changeOptionList(shopId, grpId, data);
  }

  const optionGrpSelectBtn = async (optionGrpId, text) => {
    if(optionGrpId === 0) {
      setOptionList([]);
    } else {
      let optionList = await getOptionList(optionGrpId);
      setOptionList(optionList);
    }
    document.querySelector("#menuDrgSelect .selectText").innerText = text;
    document.getElementById("menuDrgSelect").classList.remove("active");
    document.getElementById("menuDrgSelect").setAttribute("data-id", optionGrpId);
  }

  let optionGrp = optionGrpList.map((value, index) => {
    return (
      <li className="selectoption" key={index} onClick={() => optionGrpSelectBtn(value.id, value.name)}>{value.name}</li>
    )
  })

  let menuGrpBox = optionGrpList.map((value, index) => {
    return (
      <div className='menuGrpRemoveBox grpRemoveBox'  key={ index }>
        <div className='menuGrp'>
          <input type='checkbox' className='menuGrpIndex' data-id={value.id} id={`menuGrpIndex${ value.id }`} name='menuGrpIndex' />
          <label htmlFor={`menuGrpIndex${ value.id }`}>{ value.name }</label>
        </div>
      </div>
    )
  })

  const deleteOptionGrpBtn = async () => {
    let list = [];
    let deleteBox = document.querySelectorAll(".grpRemoveBox");
    deleteBox.forEach((element) => {
      let box = element.querySelector(".menuGrpIndex");

      if (box.checked) {
        let dataId = box.getAttribute("data-id");
        list.push(dataId);
      }
    })

    document.getElementById("menuRemovePopupBtn").setAttribute("disabled", true);
    deleteOptionGrp(shopId, list);
  }

  return (
    <div>
      <div>
        <div id="optionAddPopup" className='optionAddPopup resetPopup popupV2 hide'>
          <div className='popupContainer width626'>
            <div className='popupTitle'>
              <h2>옵션 그룹 추가</h2>
              <button className='closeBtn closeBtn2 resetPopupBtn' onClick={() => closeNewOptionPopup()}>
                <img src={closeV2} alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>옵션그룹명</div>
                <div className='flexContent'>
                  <input type='text' id='optionGrpNameInput' placeholder='그룹명 입력' />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>필수여부</div>
                <div className='flexContent'>
                  <div id='optionGrpStates1' className='popupSelect select selectBox' data-id={1}>
                    <div className='optionGrpStates selectText selectTextBox' data-href='optionGrpStates1'>필수</div>
                    <ul id="optionGrpStates1Ul" className='selectOptionListBox selectOptionList' data-href="optionGrpStates1">
                      <li className='selectoption' onClick={() => optionSelect1(1, "필수", 1)}>필수</li>
                      <li className='selectoption' onClick={() => optionSelect1(0, "선택", 1)}>선택</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div id="maxBtnBox1" className='popupFlexBox popupFlexBox1 maxBtnBox'>
                <div className='flexTitle'>선택 갯수</div>
                <div className='flexContent alignBox'>
                  <button className='minusBtn maxBtn' onClick={() => minusBtnEvnet(1)}><img src={ minusBtn } alt="빼기" /></button>
                  <input type='number' id='maxNumber1' defaultValue={1} />
                  <button className='plusBtn maxBtn' onClick={() => plusBtnEvnet(1)}><img src={ plusBtn } alt="더하기" /></button>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
                <div className='flexTitle'>옵션/추가금</div>
                <div className='flexContent'>
                  <div id="newOptionList1" className='newOptionList'>
                    <div className='newOptionBox'>
                      <input type='text' className='newOptionName' name='newOptionName' placeholder='옵션명' />
                      <input type='number' className='newOptionPrice priceCut100' name='newOptionPrice' /> 원
                    </div>
                  </div>
                  <button className='newOptionAddBtn' onClick={() => newOptionAddEvent(1)}>추가</button>
                </div>
              </div>
              <div className='spanBox'>
                <span>※ 사장님이 직접 수정하신 사항에 대한 책임은 사장님 본인에게 있습니다.</span><br />
                <span>※ 잘못 추가한 메뉴로 인한 손해에 대해서는 당사는 어떠한 책임도 부담하지 않습니다.</span>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn closeBtn2' onClick={() => closeNewOptionPopup()}>취소</button>
              <button type='button' id="optionAddBtn" className='optionAddBtn blueBtn' onClick={() => newOptionGrpBtn()}>확인</button>
            </div>
          </div>
        </div>

        <div id="menuRemovePopup1" className='menuRemovePopup1 resetPopup popupV2 hide'>
          <div className='popupContainer'>
            <div className='popupTitle'>
              <h2>옵션그룹 삭제</h2>
              <button className='closeBtn resetBtn' onClick={() => closePopup("menuRemovePopup1")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              { menuGrpBox }
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn resetBtn' onClick={() => closePopup("menuRemovePopup1")}>취소</button>
              <button type='button' id="menuRemovePopupBtn" className='menuRemovePopupBtn blueBtn' onClick={() => deleteOptionGrpBtn()}>확인</button>
            </div>
          </div>
        </div>

        <div id="optionSetPopup" className='optionSetPopup resetPopup popupV2 hide'>
          <div className='popupContainer width626'>
            <div className='popupTitle'>
              <h2>옵션 그룹 수정</h2>
              <button className='closeBtn closeBtn2 resetPopupBtn' onClick={() => closePopup("optionSetPopup")}>
                <img src={closeV2} alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>옵션그룹명</div>
                <div className='flexContent'>
                  <input type='text' id='optionGrpNameInput2' placeholder='그룹명 입력' />
                  <input type="hidden" id="optionGrpIndex"/>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>필수여부</div>
                <div className='flexContent'>
                  <div id='optionGrpStates2' className='popupSelect select selectBox' data-id={1}>
                    <div className='optionGrpStates selectText selectTextBox' data-href='optionGrpStates2'>필수</div>
                    <ul id="optionGrpStates2Ul" className='selectOptionListBox selectOptionList' data-href="optionGrpStates2">
                      <li className='selectoption' onClick={() => optionSelect1(1, "필수", 2)}>필수</li>
                      <li className='selectoption' onClick={() => optionSelect1(0, "선택", 2)}>선택</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div id="maxBtnBox2" className='popupFlexBox popupFlexBox1 maxBtnBox'>
                <div className='flexTitle'>선택갯수</div>
                <div className='flexContent alignBox'>
                  <button className='minusBtn maxBtn' onClick={() => minusBtnEvnet(2)}><img src={ minusBtn } alt="빼기" /></button>
                  <input type='number' id='maxNumber2' />
                  <button className='plusBtn maxBtn' onClick={() => plusBtnEvnet(2)}><img src={ plusBtn } alt="더하기" /></button>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
                <div className='flexTitle'>옵션/추가금</div>
                <div className='flexContent'>
                  <div id="newOptionList2" className='newOptionList'>
                    <div className='newOptionBox'>
                      <input type='text' className='newOptionName' name='newOptionName' placeholder='옵션명' />
                      <input type='number' className='newOptionPrice priceCut100' name='newOptionPrice' /> 원
                    </div>
                  </div>
                  <button className='newOptionAddBtn' onClick={() => newOptionAddEvent(2)}>추가</button>
                </div>
              </div>
              <div className='spanBox'>
                <span>※ 사장님이 직접 수정하신 사항에 대한 책임은 사장님 본인에게 있습니다.</span><br />
                <span>※ 잘못 추가한 메뉴로 인한 손해에 대해서는 당사는 어떠한 책임도 부담하지 않습니다.</span>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn closeBtn2' onClick={() => closePopup("optionSetPopup")}>취소</button>
              <button type='button' id="optionSetBtn" className='optionAddBtn blueBtn' onClick={() => modifyOptionGrpBtn()}>확인</button>
            </div>
          </div>
        </div>
        <div id="menuGrpPopup2" className='menuGrpPopup2 resetPopup popupV2 hide'>
          <div className='popupContainer'>
            <div className='popupTitle'>
              <h2>옵션그룹 순서 변경</h2>
              <button className='closeBtn menuGrpPopup2closeBtn' onClick={() => {
                closePopup("menuGrpPopup2");
                setReset(false);
              }}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <input type="hidden" id="optionGrpIndex2"/>
              <div id="popupDragBox1" className='popupDragBox'>
                <OptionGrpDragV2 items={optionGrpList} reset={reset} />
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn menuGrpPopup2closeBtn' onClick={() => {
                closePopup("menuGrpPopup2");
                setReset(false);
              }}>취소</button>
              <button type='button' id="menuGrp2Btn" className='menuGrp2Btn blueBtn' onClick={() => changeOptionGrpListBtn()}>확인</button>
            </div>
          </div>
        </div>
        <div id="menuPopup3" className='menuPopup3 popupV2 hide'>
          <div className='popupContainer'>
            <div className='popupTitle'>
              <h2>옵션 순서 변경</h2>
              <button className='closeBtn' onClick={() => {
                closePopup("menuPopup3");
                setReset(false);
              }}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>그룹 선택</div>
                <div className='flexContent'>
                  <div id='menuDrgSelect' className='popupSelect select selectBox' data-id={0}>
                    <div className='menuDrgSelect selectText selectTextBox' data-href='menuDrgSelect'>설정안함</div>
                    <ul id="menuDrgSelectUl" className='selectOptionListBox selectOptionList' data-href='menuDrgSelect'>
                      <li className='selectoption' onClick={() => optionGrpSelectBtn(0, "설정안함")}>설정안함</li>
                      {optionGrp}
                    </ul>
                  </div>
                </div>
              </div>
              <div id="popupDragBox2" className='popupDragBox'>
                <OptionDragV2 items={optionList} reset={reset} />
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => {
                closePopup("menuPopup3");
                setReset(false);
              }}>취소</button>
              <button type='button' id="menuPopup3Btn" className='menuPopup3Btn blueBtn' onClick={() => changeOptionListBtn()}>확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}